import {
  UNIVERSITY_WEB_DETAILS_LIST_REQ,
  UNIVERSITY_WEB_DETAILS_LIST_SUCCESS,
  UNIVERSITY_WEB_DETAILS_LIST_FAILED,
  CREATE_UNIVERSITY_WEB_DETAILS_REQ,
  CREATE_UNIVERSITY_WEB_DETAILS_SUCCESS,
  CREATE_UNIVERSITY_WEB_DETAILS_FAILED,
  CREATE_UNIVERSITY_WEB_DETAILS_RESET,
  UPDATE_UNIVERSITY_WEB_DETAILS_REQ,
  UPDATE_UNIVERSITY_WEB_DETAILS_SUCCESS,
  UPDATE_UNIVERSITY_WEB_DETAILS_FAILED,
  UPDATE_UNIVERSITY_WEB_DETAILS_RESET,
  DELETE_UNIVERSITY_WEB_DETAILS_REQ,
  DELETE_UNIVERSITY_WEB_DETAILS_SUCCESS,
  DELETE_UNIVERSITY_WEB_DETAILS_FAILED,
  DELETE_UNIVERSITY_WEB_DETAILS_RESET,
  UNIVERSITY_WEB_DETAILS_SINGLE_REQ,
  UNIVERSITY_WEB_DETAILS_SINGLE_SUCCESS,
  UNIVERSITY_WEB_DETAILS_SINGLE_FAILED,
} from "../Constants/universityWebDetailsConstants";

export const LIST_UNIVERSITY_WEB_DETAILS_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UNIVERSITY_WEB_DETAILS_LIST_REQ: {
      return { LOADING: true };
    }
    case UNIVERSITY_WEB_DETAILS_LIST_SUCCESS: {
      return { LOADING: false, UNIVERSITY_WEB_DETAILS_LISTS: payload };
    }

    case UNIVERSITY_WEB_DETAILS_LIST_FAILED: {
      return { LOADING: false, ERROR: payload };
    }

    default:
      return state;
  }
};

export const CREATE_UNIVERSITY_WEB_DETAILS_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case CREATE_UNIVERSITY_WEB_DETAILS_REQ: {
      return { create_university_web_Loading: true };
    }
    case CREATE_UNIVERSITY_WEB_DETAILS_SUCCESS: {
      return {
        create_university_web_Loading: false,
        create_university_web_Success: payload,
      };
    }

    case CREATE_UNIVERSITY_WEB_DETAILS_FAILED: {
      return {
        create_university_web_Loading: false,
        create_university_web_Error: payload,
      };
    }

    case CREATE_UNIVERSITY_WEB_DETAILS_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const UPDATE_UNIVERSITY_WEB_DETAILS_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UPDATE_UNIVERSITY_WEB_DETAILS_REQ: {
      return { update_university_web_Loading: true };
    }
    case UPDATE_UNIVERSITY_WEB_DETAILS_SUCCESS: {
      return {
        update_university_web_Loading: false,
        update_university_web_Success: payload,
      };
    }
    case UPDATE_UNIVERSITY_WEB_DETAILS_FAILED: {
      return {
        update_university_web_Loading: false,
        update_university_web_Error: payload,
      };
    }

    case UPDATE_UNIVERSITY_WEB_DETAILS_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const DELETE_UNIVERSITY_WEB_DETAILS_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case DELETE_UNIVERSITY_WEB_DETAILS_REQ: {
      return { delete_university_web_Loading: true };
    }
    case DELETE_UNIVERSITY_WEB_DETAILS_SUCCESS: {
      return {
        delete_university_web_Loading: false,
        delete_university_web_Success: payload,
      };
    }

    case DELETE_UNIVERSITY_WEB_DETAILS_FAILED: {
      return {
        delete_university_web_Loading: false,
        delete_university_web_Error: payload,
      };
    }

    case DELETE_UNIVERSITY_WEB_DETAILS_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const UNIVERSITY_WEB_DETAILS_SINGLE_DATA_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case UNIVERSITY_WEB_DETAILS_SINGLE_REQ: {
      return { university_web_singleData_Loading: true };
    }
    case UNIVERSITY_WEB_DETAILS_SINGLE_SUCCESS: {
      return {
        university_web_singleData_Loading: false,
        University_Web_SingleData: payload,
      };
    }

    case UNIVERSITY_WEB_DETAILS_SINGLE_FAILED: {
      return {
        university_web_singleData_Loading: false,
        university_web_singleData_Error: payload,
      };
    }

    default:
      return state;
  }
};
